var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}
const endpoint = "https://shopifynerds.com/?edd_action=check_license&item_id=" + d1 + "&license=" + licencekey + "&url=" + c1;
const activate = "https://shopifynerds.com/?edd_action=activate_license&item_id=" + d1 + "&license=" + licencekey + "&url=" + c1;
const resultDiv = $('#result');
$(document).ready(function() {

    $.getJSON(endpoint, (license) => {
        console.log(license);
        if (license.license && license.license === 'valid') {

        } else if (license.license && license.license === 'site_inactive' || license.license && license.license === 'inactive') {
            if (window.Shopify.designMode) {
				                $('#activate-expired').fadeOut("fast");
				$('#activate-invalid').fadeOut("fast");
				$('#activate-disabled').fadeOut("fast");
                $('body').append('<div id="activate" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0);">license not active<br><button style=" background: white; color: black; border-radius: 3px; box-shadow: 0 2px 6px #00000073; ">Activate License</button><p style="padding: 15px;color: #ffffff73;margin-top: -46px;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(3000);
                $("#activate").click(function() {

                    $.ajax({
                        type: 'GET',
                        url: activate,
                        dataType: 'json',
                        success: function(res) {
                            console.log(res);
                            $('#activate').fadeOut("fast");
                            $('body').append('<div id="activated" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0); ">Congratulations you successfully <br> activated your licence<br><p style="padding: 15px;color: #ffffff73;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(2000);
                            $('#activated').fadeOut(4000, function() {
                                $('#activated').addClass('hidemsg');
                            });

                        }
                    });



                });




            }
  
        } else if (license.license && license.license === 'disabled') {
			                       if (window.Shopify.designMode) {
				$("head", parent.document).append("<link id='wonifyanimate' href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css' type='text/css' rel='stylesheet' />");
                $(".next-tab__panel--is-active", parent.document).css("background-size", "contain");
                $(".ui-banner--status-warning", parent.document).css("display", "none");
                $(".ui-stack--vertical", parent.document).css("pointer-events", "none");
                $(".te-panel__footer", parent.document).css("pointer-events", "none");
                $(".te-top-bar__item--fill", parent.document).css("pointer-events", "none");
                $("div[component='PageSelector']", parent.document).css("pointer-events", "none");
                $(".te-preview", parent.document).css("display", "none");
				$("li[title='License']", parent.document).css("pointer-events", "all");
                $("li[title='License']", parent.document).addClass('animated infinite pulse slow');
                $(".next-tab[aria-controls='NextTabPanel-2-theme-settings']", parent.document).addClass('animated infinite flash');
                $(".theme-editor__container", parent.document).append('<div id="activate" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0);">License disabled please contact NerdlySolutions and activate again<br><button style=" background: white; color: black; border-radius: 3px; box-shadow: 0 2px 6px #00000073; ">Activate License</button><p style="padding: 15px;color: #ffffff73;margin-top: -46px;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(3000);
				setTimeout(function() {
    parent.location.reload()
}, 5000);
				$("#activate").click(function() {

                    $.ajax({
                        type: 'GET',
                        url: activate,
                        dataType: 'json',
                        success: function(res) {
                            console.log(res);
                            $('#activate').fadeOut("fast");
                            $('body').append('<div id="activated" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0); ">Congratulations you successfully <br> activated your licence<br><p style="padding: 15px;color: #ffffff73;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(2000);
                            $('#activated').fadeOut(4000, function() {
                                $('#activated').addClass('hidemsg');
                            });

                        }
                    });



                });




            }
        } else if (license.license && license.license === 'invalid') {
			                       if (window.Shopify.designMode) {
				$("head", parent.document).append("<link id='wonifyanimate' href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css' type='text/css' rel='stylesheet' />");
                $(".next-tab__panel--is-active", parent.document).css("background-size", "contain");
                $(".ui-banner--status-warning", parent.document).css("display", "none");
                $(".ui-stack--vertical", parent.document).css("pointer-events", "none");
                $(".te-panel__footer", parent.document).css("pointer-events", "none");
                $(".te-top-bar__item--fill", parent.document).css("pointer-events", "none");
                $("div[component='PageSelector']", parent.document).css("pointer-events", "none");
                $(".te-preview", parent.document).css("display", "none");
				$("li[title='License']", parent.document).css("pointer-events", "all");
                $("li[title='License']", parent.document).addClass('animated infinite pulse slow');
                $(".next-tab[aria-controls='NextTabPanel-2-theme-settings']", parent.document).addClass('animated infinite flash');
                $(".theme-editor__container", parent.document).append('<div id="activate-invalid" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0);">Invalid license please enter a valid license and try activating again<br><button id="activate-invalidbtn" style=" background: white; color: black; border-radius: 3px; box-shadow: 0 2px 6px #00000073; ">Activate License</button><p style="padding: 15px;color: #ffffff73;margin-top: -46px;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(3000);
                			setTimeout(function() {
                              console.log('checking input');
                                     $("#setting-licensekeywonify", parent.document).on('input', function() {
  $(".js-btn-loadable", parent.document).click();
	console.log('input changes detecting');
     
                                      
                                     setTimeout(function() {
                                       console.log('time to reload');
                                
    parent.location.reload()
                                     }, 6000); });}, 5000);
				$("#activate-invalidbtn").click(function() {

                    $.ajax({
                        type: 'GET',
                        url: activate,
                        dataType: 'json',
                        success: function(res) {
                            console.log(res);
                            $('#activate-invalid').fadeOut("fast");
                            $('body').append('<div id="activated" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0); ">Congratulations you successfully <br> activated your licence<br><p style="padding: 15px;color: #ffffff73;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(2000);
                            $('#activated').fadeOut(4000, function() {
                                $('#activated').addClass('hidemsg');
                            });

                        }
                    });



                });




            }
        }  else if (license.license && license.license === 'expired') {
			                       if (window.Shopify.designMode) {
				$("head", parent.document).append("<link id='wonifyanimate' href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css' type='text/css' rel='stylesheet' />");
                $(".next-tab__panel--is-active", parent.document).css("background-size", "contain");
                $(".ui-banner--status-warning", parent.document).css("display", "none");
                $(".ui-stack--vertical", parent.document).css("pointer-events", "none");
                $(".te-panel__footer", parent.document).css("pointer-events", "none");
                $(".te-top-bar__item--fill", parent.document).css("pointer-events", "none");
                $("div[component='PageSelector']", parent.document).css("pointer-events", "none");
                $(".te-preview", parent.document).css("display", "none");
				$("li[title='License']", parent.document).css("pointer-events", "all");
                $("li[title='License']", parent.document).addClass('animated infinite pulse slow');
                $(".next-tab[aria-controls='NextTabPanel-2-theme-settings']", parent.document).addClass('animated infinite flash');
                $(".theme-editor__container", parent.document).append('<div id="activate-expired" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0);">license expired renew your license and try activating again<br><button id="activate-expiredbtn" style=" background: white; color: black; border-radius: 3px; box-shadow: 0 2px 6px #00000073; ">Activate License</button><p style="padding: 15px;color: #ffffff73;margin-top: -46px;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(3000);
                				
                                     setTimeout(function() {
    parent.location.reload()
}, 5000);
				$("#activate-expiredbtn").click(function() {

                    $.ajax({
                        type: 'GET',
                        url: activate,
                        dataType: 'json',
                        success: function(res) {
                            console.log(res);
                            $('#activate-expired').fadeOut("fast");
                            $('body').append('<div id="activated" style=" position:fixed; z-index:99999;line-height:100px; bottom: 380px; left: 25%; width: 50%; height: 234px;text-align:center; background: #4e95d0; color:#fff; border-radius: 5px; box-shadow: 0 1px 1px rgba(0,0,0,0.12), 0 2px 2px rgba(0, 0, 0, 0.46), 0 4px 4px rgba(0,0,0,0.12), 0 8px 8px rgba(0,0,0,0.12), 0px 0px 200px 200px rgba(0, 0, 0, 0.33), 0px 0px 200px 200px rgba(97, 96, 96, 0.33), 0px 0px 200px 200px rgba(0, 0, 0, 0.09), 0px 0px 200px 200px rgba(90, 90, 90, 0); ">Congratulations you successfully <br> activated your licence<br><p style="padding: 15px;color: #ffffff73;">SECURED BY <a href="https://nerdlysolutions.io" style="color: #ffffff73;pointer-events: all !important;">NERDLYSOLUTIONS.IO</a></p></div>').fadeIn(2000);
                            $('#activated').fadeOut(4000, function() {
                                $('#activated').addClass('hidemsg');
                            });

                        }
                    });



                });




            }
        } 
    });
});